import ISaveModel from "../../../../../shared/src/ranj/equalture/savegame/ISaveModel";
import GameModel from "./GameModel";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import NGTScenarioPlayer from "../ngt/scenario/NGTScenarioPlayer";
import NGTVariableManager from "../ngt/base/NGTVariableManager";
import ScenarioLibrary from "../ngt/scenario/ScenarioLibrary";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class SaveModel extends ISaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(gameModel, config, scenarioLibrary, scenarioPlayer, variableManager) {
        super();
        this._gameModel = gameModel;
        this._config = config;
        this._scenarioLibrary = scenarioLibrary;
        this._scenarioPlayer = scenarioPlayer;
        this._variableManager = variableManager;

        this._saveGame = null;
    }

    setSaveGame(obj) {
        if (obj != null) {
            const currentVersion = this._config.getValue(Config.VERSION);
            if (currentVersion == obj.version) {
                this._saveGame = obj;
                console.log("SaveModel.setSaveGame", obj);
            } else {
                console.warn(`Savegame version (${obj.version}) does not correspond to current version (${currentVersion}). Ignoring savegame.`);
            }
        } else {
            console.log("SaveModel.setSaveGame, no savegame");
        }
    }

    /**
     * @returns {Object} Generic object containing save state.
     */
    getSaveGame() {
        return this._saveGame;
    }

    createSaveGame() {
        const completed = this._gameModel.completed;
        const saveGame = {
            version: this._config.getValue(Config.VERSION),
            completed: completed,
            elapsedTime: this._gameModel.elapsedTime
        };
        if (!completed && !isNull(this._scenarioLibrary.getCurrentScenario())) {
            saveGame.scenarioId = this._scenarioLibrary.getCurrentScenario().id;
            saveGame.storyMemento = this._scenarioPlayer.getStoryPlayer().save().serialize();
            saveGame.storyVariables = this._variableManager.getState();
            if (!isNull(this._gameModel.currentDialogPlayer)) {
                saveGame.dialogMemento = this._gameModel.currentDialogPlayer.dialogMemento;
            }
        }
        return saveGame;
    }
}
